import { render, staticRenderFns } from "./SmartSearch.vue?vue&type=template&id=8b8ed338&"
import script from "./SmartSearch.vue?vue&type=script&lang=js&"
export * from "./SmartSearch.vue?vue&type=script&lang=js&"
import style0 from "./SmartSearch.vue?vue&type=style&index=0&id=8b8ed338&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b8ed338')) {
      api.createRecord('8b8ed338', component.options)
    } else {
      api.reload('8b8ed338', component.options)
    }
    module.hot.accept("./SmartSearch.vue?vue&type=template&id=8b8ed338&", function () {
      api.rerender('8b8ed338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/SmartSearch.vue"
export default component.exports